
export const DEFAULT_FLAGS_ASSET_PATH = './assets/images/flags/allFlags/';
